"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var numberMeasure_1 = require("../measure/numberMeasure");
var common_1 = require("./common");
// Liquid Volume
exports.fluidOunces = numberMeasure_1.Measure.of(1.7339, common_1.inches.cubed(), "fl oz");
exports.gills = numberMeasure_1.Measure.of(5, exports.fluidOunces, "gi");
exports.pints = numberMeasure_1.Measure.of(20, exports.fluidOunces, "pt");
exports.quarts = numberMeasure_1.Measure.of(2, exports.pints, "qt");
exports.gallons = numberMeasure_1.Measure.of(4, exports.quarts, "gal");
// Mass
exports.drachms = numberMeasure_1.Measure.of(1 / 256, common_1.grains, "dr");
exports.stone = numberMeasure_1.Measure.of(14, common_1.pounds, "st");
exports.quarters = numberMeasure_1.Measure.of(2, exports.stone, "qtr");
exports.hundredweights = numberMeasure_1.Measure.of(112, common_1.pounds, "cwd");
exports.tons = numberMeasure_1.Measure.of(2240, common_1.pounds, "t");
//# sourceMappingURL=imperial.js.map